import type { Components, Theme } from '@mui/material/styles';

const MuiAvatarGroup: Components<Theme>['MuiAvatarGroup'] = {
  styleOverrides: {
    /**
     * Корневые стили AvatarGroup
     * @param root0 - пропсы
     * @param root0.theme - тема
     */
    root: ({ theme }) => ({
      '& .MuiAvatar-colorDefault': {
        backgroundColor: theme.palette.primary.main,
        fontSize: 14
      }
    })
  }
};

export const avatarGroup = {
  MuiAvatarGroup
};
